import { api } from './api';

export const roleService = {
  getAll: () => api.get('/roles').then((res) => res.data),
};
